import { APP_SESSION_BROADCAST_CHANNEL_NAME } from '../constants';
import type { AppSessionBroadcastMessage } from '../hooks/useAppSessionBroadcast';

/**
 * Identifies this tab on the channel. The module-level publisher and the hook's
 * channel are separate objects in the same tab, so a tab does receive its own
 * message; the receiver drops anything stamped with its own id.
 */
export const APP_SESSION_TAB_ID =
  globalThis.crypto?.randomUUID?.() ?? `tab-${String(performance.now())}`;

let channel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') {
    return null;
  }

  channel ??= new BroadcastChannel(APP_SESSION_BROADCAST_CHANNEL_NAME);

  return channel;
}

/**
 * Publishes an end-of-session to the other tabs from outside React, for exits
 * such as a router action that cannot call `useAppSessionBroadcast`.
 */
export function broadcastAppSessionLogout(
  reason: 'user' | 'timeout' = 'user'
): void {
  const message: AppSessionBroadcastMessage = {
    type: 'session-logout',
    reason,
    senderId: APP_SESSION_TAB_ID,
  };

  getChannel()?.postMessage(message);
}

/** Test-only teardown so a stubbed channel does not leak between cases. */
export function closeAppSessionBroadcastChannel(): void {
  channel?.close();
  channel = null;
}
